import { useState } from 'react'
import { useNavigate, Navigate } from 'react-router-dom'
import { Helmet } from '@act/react-helmet-async'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import { login, isAuthed } from '../../api/auth'

export default function AdminLogin () {
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  if (isAuthed()) {
    return <Navigate to='/admin/dashboard' replace />
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitting(true)
    setError('')
    try {
      await login(username, password)
      navigate('/admin/dashboard', { replace: true })
    } catch (err) {
      setError(err.message || 'Login failed')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      <Helmet>
        <meta name='robots' content='noindex' />
        <title>Admin Login — Peaks Sports</title>
      </Helmet>
      <Container maxWidth='xs' sx={{ mt: 10, mb: 4 }}>
        <Paper sx={{ p: 4 }}>
          <Typography variant='h5' component='h1' sx={{ mb: 3, fontWeight: 600 }}>
            Peaks Sports Admin
          </Typography>
          {error && <Alert severity='error' sx={{ mb: 2 }}>{error}</Alert>}
          <Box component='form' onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label='Username'
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoComplete='username'
              size='small'
              fullWidth
            />
            <TextField
              label='Password'
              type='password'
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete='current-password'
              size='small'
              fullWidth
            />
            <Button type='submit' variant='contained' disabled={submitting}>
              {submitting ? 'Signing in…' : 'Sign in'}
            </Button>
          </Box>
        </Paper>
      </Container>
    </>
  )
}
